module.exports = __webpack_public_path__ + "static/media/filter.7bac24f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/filter.png
// module id = 78
// module chunks = 0